import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { languageSuffixMap } from "constant"
import classes from "./KcOrderItemSpecificationItem.module.scss"

const KcOrderItemSpecificationItem = props => {
  const { specificationItem, orderItemQuantity } = props

  const i18n = useTranslation()[1]

  return (
    <div className={classes["container"]}>
      <div className={classes["row"]}>
        <b className={classes["name"]}>
          {specificationItem[`name${languageSuffixMap[i18n.language]}`]}
        </b>

        {
          !specificationItem.isSelectable &&
          <Fragment>
            <MdClose />
            <b className={classes["qty"]}>
              {specificationItem.quantity * orderItemQuantity}
            </b>
          </Fragment>
        }
      </div>
    </div>
  )
}

export default KcOrderItemSpecificationItem